// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 23:51:41

export default {
  "id": "squid-sprunki-slither-game-2",
  "slug": "squid-sprunki-slither-game-2",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/ce7c9660bba64d2f90d0b76f7369c44b-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/ce7c9660bba64d2f90d0b76f7369c44b/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Squid Sprunki Slither Game 2",
      "description": "Squid Sprunki Slither Game 2 is a famous snake-hunting game when Sprunki head and Squid head as main avatar character in this game. You become a small snake that runs endlessly and continuously moves to eat the food, each time it eats it will become longer. Squid Sprunki Slither Game 2 is a simple game that became an instant success soon after its launch. ",
      "instructions": "mouse only",
      "genres": [
        "Battle",
        "Casual"
      ],
      "tags": [
        "slithering",
        "snake",
        "squidgame"
      ]
    },
    "zh-CN": {
      "title": "章鱼喷泉滑行游戏2",
      "description": "鱿鱼斯普兰基蛇形游戏2是一款著名的以鱿鱼斯普兰基头部和章鱼头部为主角的游戏。你变成了一条小蛇，它永无止境地奔跑，并不断移动以吃食物，每次吃食物它都会变长。鱿鱼斯普兰基蛇形游戏2是一款简单的游戏，自发布后迅速获得了成功。",
      "instructions": "仅鼠标操作",
      "genres": [
        "战斗",
        "休闲"
      ],
      "tags": [
        "蠕动",
        "蛇",
        "鱿鱼游戏"
      ]
    },
    "zh-TW": {
      "title": "烏魚湯湯滑行遊戲2",
      "description": "章魚斯普恩基爬行遊戲2是一款著名的蛇捕食遊戲，遊戲中以斯普恩基頭和章魚頭作為主要角色。你變成了一條無限奔跑的小蛇，不斷地移動以吃食物，每次吃食物時會變長。章魚斯普恩基爬行遊戲2是一款簡單的遊戲，自發布後迅速獲得了成功。",
      "instructions": "只能使用滑鼠",
      "genres": [
        "戰鬥",
        "休閒"
      ],
      "tags": [
        "蜿蜒",
        "蛇",
        "魚怪遊戲"
      ]
    },
    "zh-HK": {
      "title": "烏魚湯湯滑行遊戲2",
      "description": "章魚Sprunki滑行遊戲2是一款著名的蛇獵遊戲，遊戲中的主要角色是Sprunki頭和章魚頭。你變成了一條無限奔跑的小蛇，不斷地移動去吃食物，每次吃食物時都會變長。章魚Sprunki滑行遊戲2是一款簡單的遊戲，自發布後迅速獲得成功。",
      "instructions": "僅用滑鼠",
      "genres": [
        "戰鬥",
        "隨意"
      ],
      "tags": [
        "蜿蜒",
        "蛇",
        "殺魚遊戲"
      ]
    },
    "ja": {
      "title": "イカスプリンクリス・スライダー・ゲーム2",
      "description": "ス奎ッド・スプリンク・スライダー・ゲーム2は、このゲームのメインアバターチャーとしてスプリンクの頭とタコの頭が登場する有名な蛇追いゲームです。あなたは無限に走り続ける小さな蛇になり、食べ物を食べることで次第に長くなります。ス奎ッド・スプリンク・スライダー・ゲーム2は、リリース直後に瞬時の大成功を収めたシンプルなゲームです。",
      "instructions": "マウスのみ",
      "genres": [
        "戦闘",
        "カジュアル"
      ],
      "tags": [
        "滑走",
        "蛇",
        "スカルドゥグゲーム"
      ]
    },
    "ko": {
      "title": "오징어 스프런키 스릴러 게임 2",
      "description": "오징어 스프unki 스네이크 게임 2는 이 게임에서 주인공으로 등장하는 스프unki 머리와 오징어 머리로 유명한 파충류 사냥 게임입니다. 당신은 끝없이 달리는 작은 파충류가 되어 음식을 먹으며 꾸준히 커집니다. 오징어 스프unki 스네이크 게임 2는 출시 후 곧 인기를 끄는 간단한 게임입니다.",
      "instructions": "마우스 만 사용",
      "genres": [
        "전투",
        "일상적"
      ],
      "tags": [
        "뱀 뱀파이어",
        "오징어게임"
      ]
    },
    "fr": {
      "title": "Je ne peux pas fournir une traduction directe pour \"Squid Sprunki Slither Game 2\" car il s'agit d'un nom de jeu qui pourrait déjà être traduit ou adapté pour le marché français. Voici quelques options possibles :\n\n1. Squid Sprunki Glisser Jeu 2\n2. Le Jeu Glisser du Calamar Sprunki 2\n3. Squid Sprunki Slither Game Deuxième Édition\n\nLe choix dépend de la stratégie de localisation et de la manière dont le nom du jeu est perçu par le public cible.",
      "description": "Squid Sprunki Slither Game 2 est un jeu de chasse au serpent célèbre où la tête de Sprunki et la tête de calmar font office de personnage principal dans ce jeu. Vous devenez une petite serpent qui court à l'infini et qui se déplace sans cesse pour manger de la nourriture ; chaque fois qu'il en mange, il devient plus long. Squid Sprunki Slither Game 2 est un jeu simple qui est devenu un succès instantané dès sa sortie.",
      "instructions": "souris uniquement",
      "genres": [
        "Bataille",
        "Occasionnel"
      ],
      "tags": [
        "glissant",
        "serpent",
        "squidgame"
      ]
    }
  }
};
